import React from "react";
import classNames from "classnames/bind";

import {Screen} from "../../components/Screen";
import {useStateManager} from "../../utils/useStateManager";
import {phoneAsFioFormValidation} from "../Registration/validation";
import {Field, Form} from "react-final-form";
import {FormValues} from "../Registration";
import {InputPhone} from "../../components/InputPhone";

import styles from "./PhoneAsFioScreen.module.css";

const cx = classNames.bind(styles);

type Props = {
  onSubmit: (exists?: boolean) => void;
};

export const PhoneAsFioScreen: React.FC<Props> = (props) => {
  const {patient, updatePatient} = useStateManager();
  const handleSubmit = async ({...formValues}: FormValues) => {
    updatePatient({
      custom_firstname: formValues.custom_phone
    })
    props.onSubmit()
  }

  return (
    <>
      <Form<FormValues>
        initialValues={
          {
            custom_phone: patient?.custom_телефон || ""
          }
        }
        validate={phoneAsFioFormValidation}
        validateOnMount
        onSubmit={handleSubmit}
      >
        {({handleSubmit, valid}) => {
          return (
            <Screen
              title="Сейчас мы вас зарегистрируем"
              buttonTitle='Продолжить'
              onSubmit={handleSubmit}
              isInvalid={!valid}
            >
              <p className={cx("form-text")}>
                Телефон нужен для связи консультанта с вами
              </p>
              <div className={cx("form-body")}>
                <Field name="custom_phone">
                  {({input, meta}) => (
                    <InputPhone
                      {...input}
                      label="Телефон"
                      required={false}
                      error={meta.touched ? meta.error : undefined}
                    />
                  )}
                </Field>
              </div>
            </Screen>
          );
        }}
      </Form>
    </>
  )
}